/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiWindowNewUpRightIcon16Light } from './UiWindowNewUpRightIcon16Light';
import { UiWindowNewUpRightIcon16Regular } from './UiWindowNewUpRightIcon16Regular';
import { UiWindowNewUpRightIcon16Solid } from './UiWindowNewUpRightIcon16Solid';
import { UiWindowNewUpRightIcon20Light } from './UiWindowNewUpRightIcon20Light';
import { UiWindowNewUpRightIcon20Regular } from './UiWindowNewUpRightIcon20Regular';
import { UiWindowNewUpRightIcon20Solid } from './UiWindowNewUpRightIcon20Solid';
import { UiWindowNewUpRightIcon24Regular } from './UiWindowNewUpRightIcon24Regular';
import { UiWindowNewUpRightIcon24Solid } from './UiWindowNewUpRightIcon24Solid';
import { UiWindowNewUpRightIcon32Regular } from './UiWindowNewUpRightIcon32Regular';
import { UiWindowNewUpRightIcon64Regular } from './UiWindowNewUpRightIcon64Regular';
var sizes = {
    16: {
        light: UiWindowNewUpRightIcon16Light,
        regular: UiWindowNewUpRightIcon16Regular,
        solid: UiWindowNewUpRightIcon16Solid,
    },
    20: {
        light: UiWindowNewUpRightIcon20Light,
        regular: UiWindowNewUpRightIcon20Regular,
        solid: UiWindowNewUpRightIcon20Solid,
    },
    24: {
        regular: UiWindowNewUpRightIcon24Regular,
        solid: UiWindowNewUpRightIcon24Solid,
    },
    32: {
        regular: UiWindowNewUpRightIcon32Regular,
    },
    64: {
        regular: UiWindowNewUpRightIcon64Regular,
    },
};
export var UiWindowNewUpRightIcon = forwardRef('UiWindowNewUpRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
